import type { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import type { InsuranceCalculatorType } from "web_myplann/Calculators/Types/InsuranceCalculatorType";
import { INSURANCE_CALCULATOR_TYPES } from "web_myplann/Calculators/Utils/calculatorCatalog";

export const isInsuranceCalculator = (
	type: CalculatorType,
): type is InsuranceCalculatorType =>
	INSURANCE_CALCULATOR_TYPES.some((insuranceType) => insuranceType === type);
